import axiosInstance from '@/utils/axiosInstance';

export const uploadPaymentReminderFile = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/SmartProAPI/api/payment-reminder/upload-file',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPaymentReminderFiles = async (
  page,
  size,
  sortField,
  sortDirection,
) => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/payment-reminder?page=${page}&size=${size}&sortBy=${sortField}&sortDir=${sortDirection}`,
    );
    if (response.status === 204) {
      return ['No Data Found'];
    }
    return response;
  } catch (error) {
    throw error;
  }
};

export const unloadPaymentReminderFile = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `/SmartProAPI/api/payment-reminder/${id}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPaymentReminderFileByFileId = async (id, filterType) => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/payment-reminder/${id}/details?filterType=${filterType}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const paymentReminderSenderEmail = async () => {
  try {
    const response = await axiosInstance.get(
      '/SmartProAPI/api/payment-reminder/email-senders',
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const paymentReminderSenderEmailId = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/payment-reminder/email-senders/${id}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateEmailTemplate = async (templateId, data) => {
  try {
    const response = await axiosInstance.put(
      `/SmartProAPI/api/payment-reminder/email-template/${templateId}`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getLogsList = async (page, size) => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/payment-reminder/email-records/batches?page=${page}&size=${size}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getLogsListByBatchIdAndSendStatus = async (
  batchId,
  sendStatus,
) => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/payment-reminder/email-records?batchId=${batchId}&sendStatus=${sendStatus}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const sendEmailRecords = async (data) => {
  try {
    const response = await axiosInstance.post(
      '/SmartProAPI/api/payment-reminder/send-email-records',
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const loadEmailFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await axiosInstance.post(
      '/SmartProAPI/api/payment-reminder/upload-customer-file',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const resendEmails = async (batchId) => {
  try {
    const response = await axiosInstance.put(
      `/SmartProAPI/api/payment-reminder/resend-failed/${batchId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const abortEmailRecords = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/SmartProAPI/api/payment-reminder/email-records/abort`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const dowloadLogExcelFile = async (batchId, sendStatus) => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/payment-reminder/export-excel-email-records?batchId=${batchId}&sendStatus=${sendStatus}`,
      {
        responseType: 'blob', // Important for downloading files
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPendingMailRecords = async () => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/payment-reminder/unsend-email-records`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
